import PropTypes from 'prop-types'
import React from 'react'

const SubmitButton = ({ disabled, classname, text, onClick }) =>
  <button
    type='submit'
    className={classname}
    disabled={disabled}
    onClick={onClick}
  >
    {text}
  </button>

SubmitButton.propTypes = {
  disabled: PropTypes.bool,
  classname: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  onClick: PropTypes.func
}

export default SubmitButton
